import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../core/services/auth.service';
import { NotificationService } from '../core/services';
import {
  isApiUrl,
  isLogoutUrl,
  isSignalRUrl,
} from '../core/services/auth-config';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService,
    private notificationService: NotificationService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const api = isApiUrl(req.url);
    if (!api && !isSignalRUrl(req.url)) return next.handle(req);

    // Cookie deletion must reach the server even when acquisition is unavailable.
    if (isLogoutUrl(req.url)) {
      return next.handle(
        req.clone({
          withCredentials: true,
          headers: req.headers
            .delete('Authorization')
            .delete('X-SignalR-ConnectionId'),
        }),
      );
    }

    return from(this._authService.ensureApiBearer()).pipe(
      switchMap((bearer) => {
        let headers = req.headers.set('Authorization', 'Bearer ' + bearer);
        if (api && this.notificationService.connectionId) {
          headers = headers.set(
            'X-SignalR-ConnectionId',
            this.notificationService.connectionId,
          );
        }
        return next.handle(req.clone({ withCredentials: true, headers })).pipe(
          catchError((error) => {
            // Preserve the typed server outcome. Task 7 owns the recovery/navigation.
            if (error.status === 401) this._authService.invalidateSession();
            return throwError(() => error);
          }),
        );
      }),
    );
  }
}
